import { BookmarkIcon } from '@heroicons/react/24/solid';

export type FilterButtonPropsType = {
  name: string;
  isActive: boolean;
  onClick: () => void;
};

function FilterButton({ name, isActive, onClick }: FilterButtonPropsType) {
  return (
    <button
      onClick={onClick}
      className={`
        group relative flex w-full select-none items-center justify-between gap-2
        rounded-xl border px-3 py-3.5 text-xs font-bold
        shadow-sm transition-all duration-200
        active:scale-95 sm:w-[48%]

        ${
          isActive
            ? 'border-amber-400 bg-amber-100 text-amber-800 shadow-sm'
            : 'border-zinc-200 bg-white text-zinc-500 hover:border-amber-200 hover:bg-zinc-50'
        }
      `}
    >
      <div className='flex items-center gap-2'>
        <span
          className={`
            transition-all duration-200
            ${isActive ? 'text-amber-600' : 'text-zinc-400 group-hover:text-zinc-500'}
          `}
        >
          <BookmarkIcon width={20} />
        </span>

        <span className={isActive ? 'text-amber-700' : 'text-zinc-600'}>{name}</span>
      </div>
    </button>
  );
}

export default FilterButton;
